import React from 'react';

// 解析markdown链接格式 [文本](链接)
export const parseMarkdownLinks = (text: string): string | (string | React.ReactElement)[] => {
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const parts: (string | React.ReactElement)[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = linkRegex.exec(text)) !== null) {
        // 添加链接前的普通文本
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        
        // 添加链接
        parts.push(
            <a
                key={match.index}
                href={match[2]}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1890ff', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.target as HTMLElement).style.textDecoration = 'underline'}
                onMouseLeave={(e) => (e.target as HTMLElement).style.textDecoration = 'none'}
            >
                {match[1]}
            </a>
        );
        
        lastIndex = linkRegex.lastIndex;
    }
    
    // 添加剩余的普通文本
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    
    return parts.length > 1 ? parts : text;
};

